export const INITIAL: unknown[] = [];

export interface UserDetails {
  profilePic: string | null;
  userName: string | null;
}

export interface TeamDetails {
  companyLogo: string | null;
}

export const userDetails: UserDetails = {
  profilePic: localStorage.getItem("PROFILE_PIC"),
  userName: localStorage.getItem("LOGIN_NAME"),
};

export const teamDetails: TeamDetails = {
  companyLogo: localStorage.getItem("BRAND_LOGO"),
};
